export const Colors = {
  Orange: 'rgba(255,95,0,1)',
  Error: '#D32F2F',
  White: 'rgba(255,255,255,1)',
  Grey: 'rgba(164,164,164,1)',
  Red: '#e74b3c',
  ErrorOrange: '#fe5f00',
  LightGrey: '#c8c8c8'
};
